/* tslint:disable */
/* eslint-disable */
/**
 * Melco Tracking APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrackingMelcoAnalyticsModelsAvailabilityStatusListItem
 */
export interface TrackingMelcoAnalyticsModelsAvailabilityStatusListItem {
    /**
     * 
     * @type {string}
     * @memberof TrackingMelcoAnalyticsModelsAvailabilityStatusListItem
     */
    app_id?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TrackingMelcoAnalyticsModelsAvailabilityStatusListItem
     */
    time_stamp?: Date;
    /**
     * 
     * @type {number}
     * @memberof TrackingMelcoAnalyticsModelsAvailabilityStatusListItem
     */
    passed?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackingMelcoAnalyticsModelsAvailabilityStatusListItem
     */
    failed?: number;
}

export function TrackingMelcoAnalyticsModelsAvailabilityStatusListItemFromJSON(json: any): TrackingMelcoAnalyticsModelsAvailabilityStatusListItem {
    return TrackingMelcoAnalyticsModelsAvailabilityStatusListItemFromJSONTyped(json, false);
}

export function TrackingMelcoAnalyticsModelsAvailabilityStatusListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackingMelcoAnalyticsModelsAvailabilityStatusListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'app_id': !exists(json, 'app_id') ? undefined : json['app_id'],
        'time_stamp': !exists(json, 'time_stamp') ? undefined : (new Date(json['time_stamp'])),
        'passed': !exists(json, 'passed') ? undefined : json['passed'],
        'failed': !exists(json, 'failed') ? undefined : json['failed'],
    };
}

export function TrackingMelcoAnalyticsModelsAvailabilityStatusListItemToJSON(value?: TrackingMelcoAnalyticsModelsAvailabilityStatusListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'app_id': value.app_id,
        'time_stamp': value.time_stamp === undefined ? undefined : (value.time_stamp.toISOString()),
        'passed': value.passed,
        'failed': value.failed,
    };
}


